import { render, staticRenderFns } from "./sendmoney-payment-summary.vue?vue&type=template&id=7eaf46e1&"
import script from "./sendmoney-payment-summary.vue?vue&type=script&lang=js&"
export * from "./sendmoney-payment-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports